import { MultipleTagSelector } from 'sonata-react-components';
import { DigitalAdExchangeCatalog, DOOHAdExchangeCatalog } from 'sonata-static-storage/lib/samples/adExchanges.samples';

import { useTargetingContext } from '@/contexts/Targeting/TargetingContext';
import { getAllowedAdExchangeCodes } from '../helpers/getAllowedAdExchangeCodes.helper';

export function AdExchangeSelector() {
  const {
    familyType,
    setProp,
    targeting: { adExchanges = [] },
    user
  } = useTargetingContext();

  const catalog = familyType === 'dooh' ? DOOHAdExchangeCatalog : DigitalAdExchangeCatalog;
  const allowedAdExchangeCodes = getAllowedAdExchangeCodes(user, familyType);

  const adExchangeOptions = Object.values(catalog)
    .filter(ad => allowedAdExchangeCodes.includes(ad.code))
    .map(ad => ({
      label: ad.name,
      value: ad.code
    }));

  const defaultSelectedItems = adExchanges
    .filter(ad => allowedAdExchangeCodes.includes(ad.name) && !ad.blacklisted)
    .map(ad => ad.name);

  const handleChange = (selection: string[]) => {
    const newAdExchanges = adExchanges.map(ad => {
      if (!allowedAdExchangeCodes.includes(ad.name)) {
        return ad;
      }
      return {
        ...ad,
        blacklisted: !selection.includes(ad.name),
        ...(!selection.includes(ad.name) && { distribution: 0 })
      };
    });
    setProp('adExchanges', newAdExchanges);
  };

  return (
    <MultipleTagSelector
      className="supplySource__adExchangeSelector"
      defaultSelectedItems={defaultSelectedItems}
      id="adExchange-selector"
      items={adExchangeOptions}
      mark
      onChange={handleChange}
    />
  );
}
